import { Button, Form, Input, message, Pagination, Select, Skeleton, Space } from "antd";
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import { StatusCode } from "common/enums";
import AppResult from "components/appResults";
import CardAddCours from "components/libs/cardAddCours";
import Flex from "components/libs/flex";
import ParentOrganismAddRoom from "components/parentOrganismAddRoom";
import OrganismCardClasses from "components/parentOrganismCardClasses";
import { Fragment, useCallback, useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import AppScreen from "screens/teacher/ScreenWithSidebar";
import { useGetOrganismRoomsQuery } from "store/services/teacher/classes.services";
import SearchIcon from "../../assets/images/app/search.svg";
import Classes from "../../assets/images/icons/teacher_classes.svg";
import styles from "./style.module.css";

const { Option } = Select;


const ParentOrganismRooms = () => {

    const auth = useSelector((state: RootStateOrAny) => state.auth);
    const { user } = useSelector((state) => state.auth);

    const { data: rooms, isLoading, isError, refetch } = useGetOrganismRoomsQuery(auth?.user?._id);
    const [showAddClasse, setShowAddClasse] = useState<boolean>(false);

    const [addCourseForm] = Form.useForm();
    //!STATE
    const [tempRoom, setTempRoom] = useState<any>(null);
    const [code, setCode] = useState(null);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    //STATES
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false);
    const [addCourseLoading, setAddCourseLoading] = useState(false);
    const [current, setCurrent] = useState<number>(1);

    const [filter, setFilter] = useState<string | undefined>(undefined);
    const [filteredRooms, setFilteredRooms] = useState<any>();

    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 11;

    const paginatedRooms = filteredRooms?.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    //FUNCTIONS
    const addCourse = useCallback(
        async (course: any) => {
            try {

                setAddCourseLoading(true);

                const courseData = {
                    title: course?.title,
                    isCollective: true,
                    organismId: user?._id
                };

                const response = await ROOMS_SERVICES.createRoomParentOrganism(courseData);

                if (response?.statusCode === StatusCode.CREATED) {

                    setTempRoom(response?.data);
                    ///setCurrent(2);
                    refetch();
                    message.success("Classe créé avec succès !");
                    addCourseForm.resetFields();
                    setShowAddClasse(false);

                    /* setTimeout(() => {
                        setCode(response.data);
                    }, 1500); */
                }
            } catch (error: any) {
                message.error(error?.message || "error");
            } finally {
                setAddCourseLoading(false);
            }
        },
        [addCourseForm]
    );

    const handleFilterClasses = (value: string) => {
        setFilter(value);

        if (!value) {
            setFilteredRooms(rooms);
            return;
        }

        let filtered = rooms;

        if (value === "active") {
            filtered = rooms?.data.filter(
                (room: any) =>
                    room.status &&
                    room.status === "PUBLISHED"
            );
        }

        if (value === "archived") {
            filtered = rooms?.data.filter(
                (room: any) =>
                    room.status &&
                    room.status === "ARCHIVED"
            );
        }

        if (value === "all") {
            filtered = rooms?.data;
        }

        setFilteredRooms(filtered);
    };

    const handleSearchingClasse = (e: any) => {

        const value = e.target.value.toLowerCase();

        if (value) {
            const filtered = value
                ? rooms?.data.filter((room: any) =>
                    room.title?.toLowerCase().includes(value.toLowerCase())
                )
                : rooms;

            setFilteredRooms(filtered);
        }
        else {
            setFilteredRooms(rooms?.data);
        }
    };

    const handleArchiveClass = async (classeId: string) => {
        try {
            setIsDataLoading(true);
            const response = await ROOMS_SERVICES.archiveClassroom(classeId);
            if (response?.statusCode === StatusCode.CREATED) {
                message.success("Classe archivée avec succès.");
                refetch();
            }
        } catch (error: any) {
            console.log(error);
            message.warning("Erreur survenue lors de l'archivage, merci de réessayer.");
        } finally {
            setIsDataLoading(false);
        }
    }

    const handleDeleteClass = async (classeId: string) => {
        try {
            setIsDataLoading(true);
            const response = await ROOMS_SERVICES.deleteClassroom(classeId);
            if (response?.statusCode === StatusCode.OK) {
                message.success("Classe supprimée avec succès.");
                refetch();
            }
        } catch (error: any) {
            console.log(error);
            message.warning("Erreur survenue lors de la suppression, merci de réessayer.");
        } finally {
            setIsDataLoading(false);
        }
    }

    useEffect(() => {
        if (rooms) {
            setFilteredRooms(rooms?.data);
        }
    }, [rooms]);

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [filteredRooms]);


    return (
        <AppScreen className={styles.dashboard}>
            <div className={styles.header}>
                {isMobile ? <Space style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", width: "100%" }}>
                    <div className={styles.titleBox}>
                        <div className={styles.titlePictureBox}>
                            <img src={Classes} height={isMobile ? 20 : 35}></img>
                        </div>
                        Mes classes
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%" }}>
                        <Select
                            value={filter}
                            onChange={(value) => handleFilterClasses(value)}
                            allowClear={false}
                            className="select-filter"
                            placeholder={"Filtrer"}
                        >
                            <Option value="active">Classes active</Option>
                            <Option value="archived">Classes archivées</Option>
                            <Option value="all">Toutes les classes</Option>
                        </Select>

                        <div className="search-box">
                            <Input
                                placeholder="Chercher une classe"
                                onChange={handleSearchingClasse}
                                style={{ maxWidth: isMobile ? "100%" : 400, borderRadius: "16px !important" }}
                                size="large"
                                bordered={false}
                            />
                            <img src={SearchIcon} height={15} />
                        </div>
                    </div>
                </Space> : <Space>
                    <div className={styles.titleBox}>
                        <div className={styles.titlePictureBox}>
                            <img src={Classes} height={isMobile ? 20 : 35}></img>
                        </div>
                        Mes classes
                    </div>

                    <Select
                        value={filter}
                        onChange={(value) => handleFilterClasses(value)}
                        allowClear={false}
                        className="select-filter"
                        placeholder={"Filtrer"}
                    >
                        <Option value="active">Classes active</Option>
                        <Option value="archived">Classes archivées</Option>
                        <Option value="all">Toutes les classes</Option>
                    </Select>

                    <div className="search-box">
                        <Input
                            placeholder="Chercher une classe"
                            onChange={handleSearchingClasse}
                            style={{ maxWidth: 400, borderRadius: "16px !important" }}
                            size="large"
                            bordered={false}
                        />
                        <img src={SearchIcon} height={15} />
                    </div>
                </Space>}

                <Button
                    className={styles.createClassButton}
                    onClick={() => setShowAddClasse(!showAddClasse)}
                >
                    Créer une classe
                </Button>
            </div>
            <div className={styles.main}>
                {isLoading ? (
                    <>
                        <Skeleton active />
                        <Skeleton active />
                    </>
                ) : (
                    <Fragment>
                        {!isError ? (
                            <Flex>
                                <CardAddCours
                                    onClick={() => setShowAddClasse(!showAddClasse)}
                                />

                                {!isLoading && filteredRooms?.length > 0 ? <Fragment>
                                    {paginatedRooms?.map((room: any) => (
                                        <OrganismCardClasses room={room} onArchiveClass={() => handleArchiveClass(room?._id)} onDeleteClass={() => handleDeleteClass(room?._id)} isLoading={isDataLoading} />
                                    ))}
                                </Fragment> : <div style={{ textAlign: "center", marginTop: 40 }}>
                                    <AppResult status="info" title="Aucune classe trouvée" />
                                </div>}

                            </Flex>
                        ) : (
                            <AppResult title="Une erreur est survenue !" status="404" />
                        )}
                    </Fragment>
                )}

                {/* Pagination */}
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={filteredRooms?.length}
                        onChange={(page) => setCurrentPage(page)}
                        showSizeChanger={false} // disable changing page size
                    />
                </div>
            </div>

            {/* Modal Ajout Classe */}
            <ParentOrganismAddRoom
                addCourse={addCourse}
                addCourseLoading={addCourseLoading}
                showAddClasse={showAddClasse}
                setShowAddClasse={setShowAddClasse}
                addCourseForm={addCourseForm}
                current={current}
                roomData={tempRoom}
            />
        </AppScreen>
    );

}

export default ParentOrganismRooms;